const filmstripSliders = document.querySelectorAll('[data-filmstrip-slider]');

filmstripSliders.forEach((slider) => {
  const track = slider.querySelector('.component-filmstrip__track');
  const previousButton = slider.querySelector('[data-filmstrip-prev]');
  const nextButton = slider.querySelector('[data-filmstrip-next]');

  if (!track || !previousButton || !nextButton) return;

  const images = Array.from(track.querySelectorAll('img'));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let updateFrame = null;
  let dragStartX = 0;
  let dragStartScroll = 0;
  let isDragging = false;

  const updateState = () => {
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft >= maxScroll - 1;

    slider.classList.toggle('is-at-start', atStart);
    slider.classList.toggle('is-at-end', atEnd);
    previousButton.disabled = atStart;
    nextButton.disabled = atEnd;
  };

  const requestStateUpdate = () => {
    if (updateFrame) window.cancelAnimationFrame(updateFrame);
    updateFrame = window.requestAnimationFrame(updateState);
  };

  const getImagePosition = (image) => image.offsetLeft - track.offsetLeft;

  const moveToImage = (direction) => {
    const currentPosition = track.scrollLeft;
    const positions = images.map(getImagePosition);
    const targetPosition = direction > 0
      ? positions.find((position) => position > currentPosition + 2)
      : positions.slice().reverse().find((position) => position < currentPosition - 2);

    track.scrollTo({
      left: targetPosition ?? (direction > 0 ? track.scrollWidth : 0),
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
    });
  };

  previousButton.addEventListener('click', () => moveToImage(-1));
  nextButton.addEventListener('click', () => moveToImage(1));

  track.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    moveToImage(event.key === 'ArrowRight' ? 1 : -1);
  });

  track.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    isDragging = true;
    dragStartX = event.clientX;
    dragStartScroll = track.scrollLeft;
    track.classList.add('is-dragging');
    track.setPointerCapture(event.pointerId);
  });

  track.addEventListener('pointermove', (event) => {
    if (!isDragging) return;
    event.preventDefault();
    track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
  });

  const stopDragging = (event) => {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove('is-dragging');
    if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
    requestStateUpdate();
  };

  track.addEventListener('pointerup', stopDragging);
  track.addEventListener('pointercancel', stopDragging);
  track.addEventListener('scroll', requestStateUpdate, { passive: true });
  window.addEventListener('resize', requestStateUpdate, { passive: true });

  images.forEach((image) => {
    if (!image.complete) image.addEventListener('load', requestStateUpdate, { once: true });
  });

  requestStateUpdate();
});
